<div class="ber">

  <ion-card>
    <ion-card-header>
      <ion-card-title>Bérek és pótlékok</ion-card-title>
      <ion-card-subtitle>
        A bér itt <b>időszakokban</b> él: módosításkor a régi állapot nem íródik felül, hanem
        lezárul, és új időszak nyílik. Így a korábbi riportok és a már kiadott iratok összegei
        visszamenőleg sem változnak. A dokumentumgenerátor is innen veszi a pótlék-jogcímeket
        és az adott napon érvényes bért.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-note color="warning" *ngIf="!jogosult" style="display:block;margin-bottom:10px">
        Ez a menüpont csak admin jogosultsággal használható.
      </ion-note>

      <div class="sor">
        <ion-input label="Bér állapota ekkor" label-placement="stacked" type="date"
                   [(ngModel)]="datum" (ionChange)="betolt()"></ion-input>
        <ion-searchbar placeholder="Keresés névre..." [(ngModel)]="kereses" [debounce]="150"></ion-searchbar>
        <ion-button size="small" fill="outline" (click)="gyujtoNyitva = !gyujtoNyitva">
          <ion-icon slot="start" name="pricetags-outline"></ion-icon>
          Pótlék-gyűjtő ({{ jogcimek.length }})
        </ion-button>
      </div>

      <!-- Közös pótlék-gyűjtő -->
      <div class="gyujto" *ngIf="gyujtoNyitva">
        <ion-note color="medium">
          Az itt felvitt jogcímek minden dolgozónál megjelennek pipálható sorként, az alapösszeg
          pedig kitöltésre kerül (dolgozónként felülírható). A sorrend a dokumentumok
          bértáblájának sorrendjét is meghatározza. Egy jogcím törlése a már rögzített
          bértételeket nem érinti.
        </ion-note>
        <div class="gyujto-sor" *ngFor="let j of jogcimek; let i = index">
          <span class="rendezo">
            <ion-button size="small" fill="clear" (click)="mozgatJogcim(i, -1)" [disabled]="i === 0">
              <ion-icon slot="icon-only" name="chevron-up-outline"></ion-icon>
            </ion-button>
            <ion-button size="small" fill="clear" (click)="mozgatJogcim(i, 1)"
                        [disabled]="i === jogcimek.length - 1">
              <ion-icon slot="icon-only" name="chevron-down-outline"></ion-icon>
            </ion-button>
          </span>
          <ion-input label="Jogcím" label-placement="stacked" [(ngModel)]="j.nev"
                     placeholder="pl. Osztályfőnöki pótlék"></ion-input>
          <ion-input label="Alapösszeg" label-placement="stacked" type="number"
                     [(ngModel)]="j.alap_osszeg"></ion-input>
          <ion-button size="small" fill="clear" color="danger" (click)="torolJogcim(i)">
            <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
          </ion-button>
        </div>
        <div class="gombok">
          <ion-button size="small" fill="outline" (click)="ujJogcim()">
            <ion-icon slot="start" name="add-outline"></ion-icon>Új jogcím
          </ion-button>
          <ion-button size="small" (click)="mentJogcimek()">
            <ion-icon slot="start" name="save-outline"></ion-icon>Gyűjtő mentése
          </ion-button>
        </div>
      </div>

      <div *ngIf="betoltes" class="ion-text-center ion-padding">
        <ion-spinner name="crescent"></ion-spinner>
      </div>

      <!-- Dolgozói lista -->
      <div class="lista" *ngIf="!betoltes">
        <div class="dolgozo" *ngFor="let d of szurtDolgozok">
          <div class="fej" (click)="nyit(d)">
            <span class="nev">{{ d.nev }}</span>
            <span class="muted">{{ d.munkakor || '—' }}</span>
            <span class="potlek-chipek">
              <ion-badge color="light" *ngFor="let p of d.potlekok">
                {{ p.jogcim }}: {{ ft(p.osszeg) }}
              </ion-badge>
              <ion-badge color="warning" *ngIf="d.forras === 'torzs'"
                         title="Még nincs rögzített bérváltozás, az állományi alapbér látszik">
                csak törzsadat
              </ion-badge>
            </span>
            <span class="osszeg">{{ d.oraado ? ft(d.oradij) + ' / óra' : ft(d.alapber) }}</span>
            <span class="osszeg vastag">{{ ft(d.osszesen) }}</span>
            <ion-icon [name]="d.nyitva ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
          </div>

          <div class="reszletek" *ngIf="d.nyitva">

            <!-- Rögzítő űrlap -->
            <div class="urlap" *ngIf="d.urlap">
              <h4>Bérváltozás rögzítése</h4>
              <div class="sor">
                <ion-input label="Érvényes ettől" label-placement="stacked" type="date"
                           [(ngModel)]="d.urlap.ervenyes_tol"></ion-input>
                <ion-input label="Alapbér (havi)" label-placement="stacked" type="number"
                           [(ngModel)]="d.urlap.alapber"></ion-input>
                <!-- Óraadónál nincs havi alapbér: az óradíj a díjazás alapja, és a
                     havi végösszegbe nem számít bele – az az óraszámtól függ. -->
                <ion-input label="Óradíj (óraadónál)" label-placement="stacked" type="number"
                           [(ngModel)]="d.urlap.oradij"></ion-input>
                <!-- AZ ÓRADÍJ KÉT KIEGÉSZÍTÉSE. Csak akkor van értelmük, ha van óradíj:
                     havibéresnél a helyettesítés a teljes bérből számolt óradíjból jön.
                     Ezért csak óradíj megadása után jelennek meg, és a kiszolgáló sem
                     tárolja őket óradíj nélkül. -->
                <ion-input *ngIf="d.urlap.oradij" label="Eseti helyettesítés óradíja"
                           label-placement="stacked" type="number"
                           [(ngModel)]="d.urlap.helyettesites_oradij"></ion-input>
                <ion-input *ngIf="d.urlap.oradij" label="Nem szakos óra díja"
                           label-placement="stacked" type="number"
                           [(ngModel)]="d.urlap.nemszakos_oradij"></ion-input>
                <ion-input label="Megjegyzés (pl. jogcím, határozat száma)" label-placement="stacked"
                           [(ngModel)]="d.urlap.megjegyzes" class="novekvo"></ion-input>
              </div>

              <div class="valaszto" *ngIf="d.urlap.sorok.length">
                <div class="valaszto-sor" *ngFor="let s of d.urlap.sorok">
                  <ion-checkbox [checked]="s.be" labelPlacement="end"
                                (ionChange)="jogcimValt(d.urlap, s, $event.detail.checked)">{{ s.jogcim }}</ion-checkbox>
                  <ion-input *ngIf="s.be" label="Összeg" label-placement="stacked" type="number"
                             [(ngModel)]="s.osszeg"></ion-input>
                </div>
              </div>
              <ion-note color="medium" *ngIf="!jogcimek.length" class="ures">
                A pótlék-gyűjtő még üres – fent nyithatod meg és viheted fel a jogcímeket.
              </ion-note>

              <div class="egyeb-sor" *ngFor="let p of d.urlap.egyeb; let i = index">
                <ion-input label="Egyedi jogcím" label-placement="stacked" [(ngModel)]="p.jogcim"
                           placeholder="pl. eseti megbízás"></ion-input>
                <ion-input label="Összeg" label-placement="stacked" type="number" [(ngModel)]="p.osszeg"></ion-input>
                <ion-button size="small" fill="clear" color="danger" (click)="torolEgyeb(d.urlap, i)">
                  <ion-icon slot="icon-only" name="close"></ion-icon>
                </ion-button>
              </div>

              <div class="gombok">
                <ion-button size="small" fill="outline" (click)="ujEgyeb(d.urlap)">
                  <ion-icon slot="start" name="add-outline"></ion-icon>Egyedi pótlék
                </ion-button>
                <ion-button size="small" (click)="rogzit(d)" [disabled]="!jogosult">
                  <ion-icon slot="start" name="save-outline"></ion-icon>
                  Rögzítés ({{ ft(urlapOsszesen(d.urlap)) }})
                </ion-button>
              </div>
            </div>

            <!-- Bértörténet -->
            <div class="tortenet">
              <h4>Bértörténet</h4>
              <div *ngIf="!d.tortenet" class="muted">Betöltés…</div>
              <ion-note color="medium" *ngIf="d.tortenet && !d.tortenet.length" class="ures">
                Még nincs rögzített bérváltozás. Az első rögzítés után itt látszik minden korábbi
                időszak is.
              </ion-note>
              <div class="idoszak" *ngFor="let i of d.tortenet">
                <div class="idoszak-fej">
                  <b>{{ i.tol }} – {{ i.ig || 'jelenleg' }}</b>
                  <span class="osszeg vastag">{{ ft(i.osszesen) }}</span>
                  <span class="muted" *ngIf="i.megjegyzes">{{ i.megjegyzes }}</span>
                  <ion-button size="small" fill="clear" color="danger" (click)="torolIdoszak(d, i)"
                              [disabled]="!jogosult">
                    <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                  </ion-button>
                </div>
                <div class="idoszak-sorok">
                  <span *ngIf="i.alapber">Alapbér: <b>{{ ft(i.alapber) }}</b></span>
                  <span *ngIf="i.oradij">Óradíj: <b>{{ ft(i.oradij) }}</b> / óra</span>
                  <span *ngIf="i.helyettesites_oradij">Eseti helyettesítés: <b>{{ ft(i.helyettesites_oradij) }}</b> / óra</span>
                  <span *ngIf="i.nemszakos_oradij">Nem szakos óra: <b>{{ ft(i.nemszakos_oradij) }}</b> / óra</span>
                  <span *ngFor="let p of i.potlekok">{{ p.jogcim }}: <b>{{ ft(p.osszeg) }}</b></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ion-note color="medium" *ngIf="!szurtDolgozok.length" class="ion-padding" style="display:block">
          Nincs a keresésnek megfelelő dolgozó.
        </ion-note>
      </div>
    </ion-card-content>
  </ion-card>
</div>
